import React, { useContext } from 'react'
import { WebTagContext } from '../../context/WebTagContext'
import { WebTagError } from '../web-tag-error/WebTagError'
import { WebTagStep1 } from '../web-tag-step-1/WebTagStep1'
import { WebTagStep2 } from '../web-tag-step-2/WebTagStep2'
import { WebTagStep3 } from '../web-tag-step-3/WebTagStep3'
import { WebTagSuccess } from '../web-tag-success/WebTagSuccess'

export const WebTagWizard = () => {
    
    const { step, transaction } = useContext(WebTagContext);

    return (
        <>
            <WebTagStep1 />
            <WebTagStep2 />   
            <WebTagStep3 />
            { step.current === 4 && <WebTagSuccess transaction = { transaction.code } /> }
        </>
    );
}
